import type { CSSProperties } from 'react';
import estilos from './StatusDot.module.css';

interface StatusDotProps {
  color: string;
  /** Diámetro en píxeles. */
  tamano?: number;
  /** Añade resplandor: indica que el estado está activo. */
  encendido?: boolean;
  /** Parpadeo suave, reservado para lo que exige atención inmediata. */
  latiendo?: boolean;
  /** Texto a la derecha del punto. */
  texto?: string;
  /**
   * Descripción para lectores de pantalla.
   * Imprescindible cuando el punto no lleva texto: el color por sí solo no es
   * información accesible.
   */
  etiqueta?: string;
}

export function StatusDot({
  color,
  tamano = 10,
  encendido = false,
  latiendo = false,
  texto,
  etiqueta,
}: StatusDotProps) {
  const estilo = {
    '--dot-color': color,
    width: tamano,
    height: tamano,
  } as CSSProperties;

  return (
    <span className={estilos.contenedor} role="status" aria-label={etiqueta ?? texto}>
      <span
        className={[
          estilos.punto,
          encendido ? estilos.encendido : '',
          latiendo ? estilos.latiendo : '',
        ]
          .filter(Boolean)
          .join(' ')}
        style={estilo}
        aria-hidden
      />
      {texto && (
        <span className={estilos.texto} style={{ '--dot-color': color } as CSSProperties}>
          {texto}
        </span>
      )}
    </span>
  );
}
